import React from "react";
import { ResetPasswordSent } from "../../components/ResetPassword/ResetPasswordSent";

const ResetPasswordSentPage = (): React.ReactElement => <ResetPasswordSent />;

export default ResetPasswordSentPage;
